(function () {
  if (window.guardenStorageGalleryReady) return;
  window.guardenStorageGalleryReady = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-cover-storage-media]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var section = link.closest('[data-section-type="product"]');
    if (!section) return;
    var mediaId = link.getAttribute('data-cover-storage-media');
    var slides = Array.from(section.querySelectorAll('[data-js-product-media-slider] .js-product-gallery-slide'));
    var slide = slides.find(function (item) { return item.getAttribute('data-media-id') === mediaId; });
    if (!slide) return;
    var slider = slide.closest('[data-js-product-media-slider]');
    var swiper = slider && slider.swiper;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (swiper && !swiper.destroyed) {
      var index = Array.from(swiper.slides).indexOf(slide);
      if (index < 0) return;
      event.preventDefault();
      swiper.slideTo(index, 0);
    } else {
      var media = slide.closest('[data-media-layout]');
      if (media && media.getAttribute('data-media-layout') === 'carousel') return;
      event.preventDefault();
    }
    slide.setAttribute('tabindex', '-1');
    slide.focus({ preventScroll: true });
    requestAnimationFrame(function () {
      (swiper && !swiper.destroyed ? slider : slide).scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'center' });
    });
  });
})();
